import { all } from "redux-saga/effects";
import catalogueSaga from "./pos/catalog";
import posSettingsSaga from "./pos/posSettings";
import businessSaga from "./business";
import discountSaga from "./discount";
import customer from "./pos/customer";
import register from "./login/register";
import support from "./support";
import login from "./login/login";
import checkout from "./checkout";
import loyalty from "./loyalty";
import tableViewSaga from "./tableView";
import itemsStatusSaga from "./itemStatus";
import outletStatusSaga from "./outletStatus";
import saleSaga from "./sale";
import myOrderSaga from "./myOrder";
// my-orders v2 owns its reads (D13): one worker for all ten lists, registered
// beside v1's, which keeps serving v1 web and the flows that still dispatch its actions
import ordersV2Saga from "../../myOrders/saga";
import printerSaga from "./printer";
import saleSummary from "./saleSummary";
import cashRegister from "./cashRegister";
import localServer from "./localServer";
import commonSaga from "./commonSaga";
import notificatonSaga from "./notifications";
import inventory from "./inventory";
import licenceExpirySaga from "./licenceExpirySaga";
import fetchCatalogSaga from "./login/fetchCatalog";
import recommenderSaga from "./recommender";
import releaseNotesSaga from "./releaseNotes";
import { createSharedSagas } from "./shared";

export * from "./shared";

/**
 * WEB variant of the root saga. See `./shared.ts` for why the two lists cannot be shared.
 *
 * This platform runs **27** domain sagas — the other runs 24. The three it does not have are
 * `inventory`, `login/fetchCatalog` and `releaseNotes`, each already a single-variant folder
 * in this tree.
 *
 * The import order, the local names (`notificatonSaga`'s spelling included) and the call
 * order are transcribed from the app file unchanged: `all()` forks in array order, so this
 * list IS the boot sequence.
 */
export default function* RootSaga(): any {
  yield all([
    catalogueSaga(),
    businessSaga(),
    posSettingsSaga(),
    discountSaga(),
    customer(),
    register(),
    login(),
    checkout(),
    loyalty(),
    tableViewSaga(),
    itemsStatusSaga(),
    outletStatusSaga(),
    saleSaga(),
    myOrderSaga(),
    ordersV2Saga(),
    printerSaga(),
    support(),
    saleSummary(),
    cashRegister(),
    localServer(),
    commonSaga(),
    notificatonSaga(),
    inventory(),
    licenceExpirySaga(),
    fetchCatalogSaga(),
    recommenderSaga(),
    releaseNotesSaga(),
    ...createSharedSagas(),
  ]);
}
